// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Keep styling aligned with app theme */
/*.form-label {*/
/*  font-weight: 500;*/
/*}*/

/* Keep the printable area rendered so Angular evaluates bindings,
   but position it far off-screen so it is not visible in the form UI. */
.fa-print-source {
  position: absolute !important;
  left: -99999px !important;
  top: -99999px !important;
  /* do not use display:none; as that prevents rendering/binding */
}

/* Hide numeric input spinners for direct decimal entry */
input.no-spinner::-webkit-outer-spin-button,
input.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input.no-spinner[type='number'] {
  -moz-appearance: textfield;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
